import React from 'react'

export default () => {
  return(
    <div style={{userSelect:'none'}}>
      <h1 className="display-4">About Tweets</h1>
      <p className="lead">Simple App to tweet whatever your mood favours</p>
      <p className="text-secondary">Version 1.2.0</p>
    </div>
  )
}
